export default __webpack_public_path__ + "static/media/powered-by-healthunlocked.e829c7ba.png";